import WidgetModel from '../widget-model'
import InitiativeTimelineView from './initiative-timeline-widget-view'
import _ from 'lodash'

const LEFT_PANE_WIDTH = 250

var InitiativeTimeline = WidgetModel.extend({
	containerDefaults: {
		width: 650,
		height: 300,
		minWidth: function () {
			let minWidth = 30
			if (this.properties.get('showLeftPane')) {
				minWidth += LEFT_PANE_WIDTH
			}

			return minWidth
		},
		minHeight: function () {
			let minHeight = 50
			if (this.properties.get('showFooter')) {
				minHeight += 55
			}

			if (this.properties.get('label')) {
				minHeight += 35
			}

			return minHeight
		}
	},

	viewCls: InitiativeTimelineView,

	section: _.constant('initiatives'),

	multiSettableProps: [ 'background', 'showLeftPane', 'showFooter', 'initialExpansion' ]

})

export default InitiativeTimeline
export { LEFT_PANE_WIDTH }

InitiativeTimeline.__filename__ = 'dashboards/widgets/initiative-timeline/initiative-timeline-widget-model.js'
